import { GeneralNoInventoryProps } from "./empty-inventory.types";
import { empty } from "~/assets/img";
import { useTranslation } from "react-i18next";
import styles from "./empty-inventory.module.css";

const EmptyInventory = ({
  className,
  texNotInventory
}: GeneralNoInventoryProps) => {
  const { t } = useTranslation();

  const handleReload = () => {
    window.location.reload();
  };

  return (
    <div
      aria-label='no-inventory-wrapper'
      className={`${className} ${styles.noInventory}`}>

      <div className={styles.empty} data-testid='no-inventory-empty'>
        <div className={styles.emptyImg}>
          <img
            src={empty}
            className={styles.emptyImg}
            alt='empty'
            data-testid='no-inventory-empty-img' />

        </div>
        <p
          className={styles.emptyTextInventory}
          data-testid='no-inventory-empty-text-description'>

          {texNotInventory}
        </p>
      </div>
    </div>);

};

export default EmptyInventory;